export default "__VITE_ASSET__D7bm_Gq4__"